//External Libraries
import { Alert, Button, Dialog, DialogContent, DialogActions, Divider } from '@mui/material';

// Icons
import { Cancel, Save } from '@mui/icons-material';

// Local components
import CustomDialogTitle from './CustomDialogTitle';

function ConfirmationModal(props) {
  const { open, title, message, onConfirm, onCancel } = props;

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <CustomDialogTitle title={title} />

      <DialogContent>
        <Alert severity="warning">{message}</Alert>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button
          variant="outlined"
          onClick={onCancel}
          startIcon={<Cancel />}
          color='primary'
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={onConfirm}
          startIcon={<Save />}
        >
          Confirm Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmationModal